export const MODAL_NAME = 'userBlock'
export const MODAL_ACTION_SUBMIT = 'userBlockSubmit'
